export default "__VITE_PUBLIC_ASSET__351851b4__"